var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"nonzero"},[React.createElement("path",{"d":"M8.75.5a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5Zm0 3a5.25 5.25 0 1 1 0 10.5 5.25 5.25 0 0 1 0-10.5Z","key":0}),React.createElement("path",{"d":"m12.129 14.25 2.121-2.121 8.421 8.421-2.121 2.121z","key":1})]));
}

Search.defaultProps = {"viewBox":"0 0 23 23"};

module.exports = Search;

Search.default = Search;
